module.exports = __webpack_public_path__ + "media/usp-diets-63b86561.svg";